const NAMESPACE = 'playbackHistory';

export const getSelectPlaybackHistory = (id) => (state) => state?.[NAMESPACE]?.[id] || 0;
